import { Box } from '@chakra-ui/react';
import CardHeader from './CardHeader';
import Table from './table';
import { useEditDetail } from '@pages/ConsumerPromotion/hooks/state/useEditDetail';
import { useMutateDetail } from '@pages/ConsumerPromotion/hooks/mutate/useMutateDetail';
import { useFileUploadPopUp } from '@store/useFileUploadPopUp';
import { useSnackbarNotification } from '@store/snackbarNotification';
import { fileDownloader } from '@helpers/utils';
import usePaginationStore from '@pages/ConsumerPromotion/hooks/state/usePagination';

export default function EditSku() {
    const stateEdit = useEditDetail();
    const { data } = usePaginationStore();
    const { set } = useFileUploadPopUp();
    const { updateDetailSku, uploadFileSkuList, cancelUploadFileSkuList } = useMutateDetail();
    const { onChangeSnackbarNotification } = useSnackbarNotification();
    const disabledEdit = ['reject', 'active', 'waiting for approval', 'ready to claim', 'done', 'processing'].includes(
        stateEdit?.overviewData?.promotion_status?.status?.toLowerCase()
    );

    const handleDownloadTemplate = async () => {
        try {
            await fileDownloader({
                url: '/api/v1/promotion-claim/download/template-sku',
                fileName: 'Template upload daftar SKU.xlsx',
            });

            onChangeSnackbarNotification({
                status: 'success',
                description: 'Template berhasil didownload!',
                duration: 3,
            });
        } catch (err) {
            onChangeSnackbarNotification({
                status: 'error',
                description: 'Template gagal didownload!',
                duration: 3,
            });
        }
    };

    const controller = new AbortController();
    const handleUploadFile = async () => {
        const { files } = useFileUploadPopUp.getState();
        const { upload_token } = useEditDetail.getState();
        if (!files?.[0]) return;

        uploadFileSkuList.mutate({
            promotion_id: stateEdit.id,
            file: files[0],
            upload_token,
            controller,
        });
    };

    const handleCancelUpload = () => {
        const { upload_token } = useEditDetail.getState();

        controller.abort();
        cancelUploadFileSkuList.mutate({
            promotion_id: stateEdit.id,
            upload_token,
        });
    };

    const handleUpload = () => {
        set({
            isOpen: true,
            title: 'Upload Daftar SKU',
            onUploadFile: handleUploadFile,
            uploadProgressMessage: 'Sedang memeriksa data produk master ...',
            onDownloadTemplate: handleDownloadTemplate,
            isCanCancelUpload: true,
            onCancelUpload: handleCancelUpload,
        });
    };

    const handleEdit = () => {
        stateEdit.set({ isEdit: true });
    };

    const handleSave = () => {
        updateDetailSku.mutate({ id: stateEdit.id, payload: { products: data } });
    };

    return (
        <Box>
            <CardHeader
                title={`${stateEdit.isEdit ? 'Masukkan ' : ''}SKU untuk Promo`}
                btnLabel="Upload Daftar SKU"
                handleUpload={handleUpload}
                handleEdit={handleEdit}
                handleSave={handleSave}
                isEdit={stateEdit.isEdit}
                isCanEdit={stateEdit.isCanEdit && !disabledEdit}
                isDisabled={disabledEdit}
            />

            <Table />
        </Box>
    );
}
